module.exports = "<div class=\"emoji-panel e-face hide\"> <div class=page-container> <ul class=\"system emoji-container\"></ul> </div> <div class=\"navigator-wrapper e-face hide\"> <div class=\"navigator-container e-face\"></div> <li class=\"scroll-left icon-corner-left e-face disabled\"></li> <li class=\"scroll-right icon-corner-right e-face disabled\"></li> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/template/emojiPanel.html
// module id = 241
// module chunks = 0